import { useMutation } from '@tanstack/vue-query'
import type { ChangeContractInput } from '~/resources/graphql/graphql'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'

export function useGiftCardChangeContractMutation() {
    const query = useRpQuery()
    const activeFacility = useActiveFacility()

    return useMutation({
        mutationFn: (mutationData: ChangeContractInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation GiftCardChangeContractMutation(
                        $input: ChangeContractInput!
                        $facilityId: ID!
                    ) {
                        changeContract(input: $input) {
                            __typename
                            ... on ChangeContractResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseGiftCardContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id
                }
            )
    })
}
